import {
    Component,
    EventEmitter,
    Inject,
    Input,
    LOCALE_ID,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
} from '@angular/core';
import { EnrollPatientDeviceDataService } from '../../../services/enroll-patient-device-data.service';
import {
    PatientDetailsModel
} from '../../../models/enroll-patient-device-data.model';
import { ActivatedRoute } from '@angular/router';
import {
    SpinnerService,
} from 'merlin-library';
import { HelperService } from 'merlin-core';

import { DatePipe } from '@angular/common';
import { DateTimeService } from '../../followup-schedule/date-time.service';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from '../../followup-schedule/customDateAdapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { UserProfileObject, UserService } from 'merlin-library';
import { ViewEncapsulation } from '@angular/core';
import { FunctionMode } from '../../enums/enroll-patient.enum';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';
import { TransmissionDetailService } from '../../../services/transmission-detail.service';
import { Subject, Subscription } from 'rxjs';
import { LocalizationService, ReturnType } from 'src/core/utilitites/localization.service';

export const PICK_FORMATS = {
    parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Component({
    selector: 'view-manual-patient-device-data',
    templateUrl: './view-patient-device-data-view.component.html',
    styleUrls: ['./view-patient-device-data-view.component.scss'],
    providers: [
        DatePipe,
        DateTimeService,
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [DateTimeService],
        },
        { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ViewPatientDeviceDataComponent implements OnChanges, OnDestroy {
    public showPhysicianOpt: boolean = false;
    public isNGQCategory = false;
    public isICMCategory = false;
    public isLPCategory: boolean = false;
    public dataMiningFlg: boolean = false;
    public toggleEmergencyCont = false;
    public dateLabel: string;
    public countryCd;
    private destroy$ = new Subject<void>();
    private profileSubscription: Subscription;
    displayMode: string = FunctionMode.VIEW;
    patRes: any = {};
    patResSet = false;
    orderTransmitterMsg: string = '';
    activatorClinicFlg: boolean = false;
    userProfile: UserProfileObject;
    releasePatientMsg='';
    isPatientRelease: boolean = false;
    @Input('functionMode') functionMode: string;
    @Input() patientid;
    @Input() isBack;
    @Input() defaultPatientDetails: PatientDetailsModel;
    @Input() getUserObsFunc;
    @Input() getUserProfFunc;
    @Input() getDeviceDataFunc;
    @Output() navigateToTrans = new EventEmitter();
    @Output() getPatientId = new EventEmitter();
    @Output() setPatientHeader = new EventEmitter();
    @Output() setSubMenu = new EventEmitter();
    constructor(
        private helperService: HelperService,
        private spinnerSer: SpinnerService,
        private userService: UserService,
        @Inject(LOCALE_ID) public locale: string,
        private enrollService: EnrollPatientDeviceDataService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private transmissionDetailService: TransmissionDetailService,
        private localizationService: LocalizationService,
    ) {
    }

    /**
     * Helper to safely get primary patient device from API response.
     * API returns patientDevices as an array - returns first device or null.
     */
    private getPrimaryPatientDevice(data: any): any {
        if (!data) return null;
        if (data.patientDevices && Array.isArray(data.patientDevices) && data.patientDevices.length > 0) {
            return data.patientDevices[0];
        }
        return null;
    }

    ngOnInit() {
        this.setUpComponent();
        this.toggleEmergencyCont = false;
        this.getUserObsFunc((existingUser) => {
            if (!existingUser) {
               this.getUserProfFunc((userProf) => {
                    this.mapUserProfileVals(userProf);
                });
            } else {
                this.mapUserProfileVals(existingUser);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngOnDestroy(): void {
        if(this.profileSubscription){
            this.profileSubscription.unsubscribe();
        }
        this.toggleEmergencyCont = false;
        this.destroy$.next();
        this.destroy$.complete();
    }

    setUpComponent() {
        this.getDeviceData();
    }

    mapUserProfileVals(userProfToSet: UserProfileObject){
        this.userProfile = userProfToSet;
        this.activatorClinicFlg = userProfToSet.activatorClinicFlg;
        this.dateLabel = userProfToSet?.dateFormat?.toUpperCase();
        this.countryCd = userProfToSet.clinicCountryCd;
    }

    public getDeviceData(emergency: boolean = false) {
        this.spinnerSer.visibility = true;
        this.patResSet = false;
        let res = this.route.snapshot.params;
        if (res?.id) {
            this.patientid = res.id;
            this.enrollService.patientId.next(res.id);
        }

        this.getDeviceDataFunc(
            this.functionMode,
            this.patientid,
            (res) => {
                const patientDevice = this.getPrimaryPatientDevice(res);
                this.bindData(emergency, res);
                this.enrollService.setPatientRpCapableFlg(patientDevice?.patientRpCapableFlg);
                localStorage.setItem('rpCapableFlg', String(patientDevice?.patientRpCapableFlg ?? false));
                this.getPatientProfile(res);
            },
            (err) => {
                this.helperService.showErrorToastr(err);
                this.spinnerSer.visibility = false;
            }
        );
    }

    bindData(emergency, res) {
        const patientDevice = this.getPrimaryPatientDevice(res);
        this.setHeader(res);
        const rpCapableValue = patientDevice?.patientRpCapableFlg ?? false;
        localStorage.setItem('rpCapableFlg', String(rpCapableValue));
        let capableFlg = rpCapableValue;
        //console.log(capableFlg);
        this.emitSubMenuData(patientDevice?.isICMDevice);
        this.patRes = JSON.parse(JSON.stringify(res));
        this.requestService.setPatientProfile(this.patRes);
        this.patResSet = true;
        this.dataMiningFlg = res.patient.dataMiningFlg;
        this.spinnerSer.visibility = false;
        const lpOpt = this.patRes?.clinicDetails?.avrProdIds?.split(',');
        let icmOpt = this.patRes?.clinicDetails?.icmProdIds?.split(',');
        let ngqOpt = this.patRes?.clinicDetails?.ngqProdIds?.split(',');
        let productId = patientDevice?.productId?.toString();
        if (lpOpt && lpOpt.indexOf(productId) > -1) {
            this.isLPCategory = true;
            this.isICMCategory = false;
            this.isNGQCategory = false;
        } else {
            this.isLPCategory = false;
        }
        if (icmOpt && icmOpt.indexOf(productId) > -1) {
            this.isICMCategory = true;
            this.isNGQCategory = false;
        } else {
            this.isICMCategory = false;
        }
        if (ngqOpt && ngqOpt.indexOf(productId) > -1) {
            this.isICMCategory = false;
            this.isNGQCategory = true;
        } else {
            this.isNGQCategory = false;
        }
    }

    getPatientProfile(res) {
        const patientDevice = this.getPrimaryPatientDevice(res);
        if (res && this.activatorClinicFlg && patientDevice) {
            let banner = {
                deviceFullDescription: patientDevice?.deviceFullDescription,
                firstName: res?.patient?.firstName,
                lastName: res?.patient?.lastName,
                patientNum: res?.patient?.patientNum
            }
            this.transmissionDetailService.setBanner(banner);
        }
        this.enrollService.setAssociatedClinicFlag(res.clinicDetails.associatedClinicFlg);
        this.enrollService.setPatientRpCapableFlg(patientDevice?.patientRpCapableFlg);
         if (
                    res.actionMsg?.msg &&
                    (res.actionMsg?.msg === 'msg.pa892.text' ||
                res.actionMsg?.msg === 'msg.patrel_regclinic.text')
                ) {
                    let message = this.translate(
                        res.actionMsg?.msg,
                        { 0: res.actionMsg.data[0], 1: res.actionMsg.data[1] },
                        ReturnType.HTML
                    );
                    this.isPatientRelease = true;
                    this.releasePatientMsg = message;
                }
    }

      translate(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }

    handleEmergencyCont(event) {
        const { $event, isEmerGencyOpen, cancelledUnsavePopup } = event;
        this.toggleEmergencyCont = $event;
        if (this.profileMode() && !$event) {
            if (this.displayMode === 'view') {
                if (!isEmerGencyOpen) {
                    this.setDisplayMode('view');
                }
            } else {
                this.setDisplayMode('edit');
            }
        }
    }

    profileMode() {
        if (this.functionMode === FunctionMode.PROFILE) {
            return true;
        } else {
            return false;
        }
    }

    setDisplayMode(value: string) {
        this.displayMode = value;
    }

    profileSaveButtonClick() { }

    setHeader(data) {
        this.setPatientHeader.emit({
            name: `${data.patient.firstName} ${data.patient.lastName}`,
            deviceName: this.getDeviceName(data),
            num: data.patient.patientNum,
        });
    }

    emitSubMenuData(val: boolean) {
        this.setSubMenu.emit(val);
    }

    getDeviceName(data) {
        let patDevice = data.dropdowns?.devices.filter((dev) => {
            return dev.value == data.patientDevices?.[0]?.productId;
        });
        if (patDevice.length == 0) {
            return '';
        }
        return patDevice[0].label;
    }
}
